module.exports = __webpack_public_path__ + "img/canvasLogo.1d1bdd8b.png";